<ion-col [class.from-menu]="fromMenu" class="wrapper ion-no-padding" role="region" aria-label="Shopping cart">
	<!-- Accessible header with button elements -->
	<header class="toolbar" role="banner">
		<!-- Back button with keyboard accessibility -->
		<button class="toolbar-button bsg-back-button" (click)="close()" aria-label="Back" tabindex="0">
			<ion-icon src="../../../assets/dean_and_david/back.svg" aria-hidden="true"></ion-icon>
			<span class="visually-hidden">Back</span>
		</button>

		<h1 class="title">{{ 'menu_page.basket_title' | translate }}</h1>

		<!-- Close button with keyboard accessibility -->
		<button class="toolbar-button bsg-close-button" (click)="close()" aria-label="Close cart" tabindex="0">
			<ion-icon src="../../../assets/dean_and_david/cross_black.svg" aria-hidden="true"></ion-icon>
			<span class="visually-hidden">Close</span>
		</button>
	</header>

	<ng-container *ngIf="order">
		<!-- Cart content area with items -->
		<div class="ordered-articles" role="list">
			<div class="ordered-articles-container" *ngIf="hasArticles">
				<div class="order-list">
					<ng-container *ngFor="let articleGroup of order.orderedArticles; trackBy: identify; let i = index">
						<app-order-list
							[venue]="venue"
							(action)="onAction(i, $event)"
							[articleGroup]="articleGroup"
							[editable]="!loading"
							[order]="order"
							role="listitem"
						>
						</app-order-list>
					</ng-container>
				</div>
			</div>

			<!-- Empty cart message -->
			<div [class.card-actions]="!hasArticles">
				<div *ngIf="!hasArticles" class="ion-text-center no-articles" role="status">
					<h3>{{ 'order.basket_empty' | translate }}</h3>
				</div>
			</div>

			<!-- Add more items button -->
			<button class="add-more" (click)="backToMenu()" aria-label="Add more items to your order" tabindex="0">
				<ion-img class="add-button" src="../../../assets/dean_and_david/add-more-btn.svg" aria-hidden="true"></ion-img>
				<h2 class="add-text">{{ 'order.add_more' | translate }}</h2>
			</button>
		</div>
	</ng-container>

	<!-- Recommendations section -->
	@if (hasArticles && recommendationArticles?.length > 0) {
		<section class="recommenation_section" role="region" aria-labelledby="recommendations-heading">
			<h3 id="recommendations-heading" class="recom_title">{{ 'recomendation_title' | translate }}</h3>
			<div class="recommenation_section_articles">
				<swiper-container
					#swiperSlider
					swiperElement
					[autoplay]="{ delay: 2000 }"
					[loop]="true"
					[slidesPerView]="3.3"
					role="list"
					aria-label="Recommended items"
				>
					@for (article of recommendationArticles; track $index) {
						@if (article._id) {
							<swiper-slide role="listitem">
								<button
									class="recommenation_section_articles__item"
									(click)="addArticle(article)"
									tabindex="0"
									[attr.aria-label]="
										'Add ' +
										(article.name | langObservable | async) +
										' for ' +
										numberToCurrency(numberD(article.price), order.currency)
									"
								>
									<p class="price">
										{{ numberToCurrency(numberD(article.price), order.currency) }}
									</p>
									<img
										*ngIf="article?.assets?.medium"
										[src]="article?.assets?.medium"
										[attr.alt]="'Image of ' + (article.name | langObservable | async)"
									/>
									<img
										*ngIf="!article?.assets?.medium"
										src="../../../assets/dean_and_david/logo.png"
										alt="Default product image"
									/>

									<div class="item-details">
										<div class="left-section">
											<h4 class="name">{{ article.name | langObservable | async }}</h4>
											<ng-container *ngIf="checkPfandTag(article) as valuePfand">
												<p
													class="deposit_text"
													[class.deposit15]="valuePfand === 'deposit15'"
													[class.deposit25]="valuePfand === 'deposit25'"
												>
													{{ 'deposit.' + valuePfand | translate }}
												</p>
											</ng-container>
										</div>
									</div>

									<!-- Add to cart button -->
									<button
										class="add_button"
										(click)="openModal(article); $event.stopPropagation()"
										aria-label="Customize and add to cart"
									>
										{{ 'add_promo' | translate }}
									</button>
								</button>
							</swiper-slide>
						}
					}
				</swiper-container>
			</div>
		</section>
	}

	<!-- Cart footer with totals and checkout button -->
	<footer class="footer" role="contentinfo">
		<!-- Age verification checkbox -->
		<ion-row *ngIf="showAgeVefiried" class="age-verified">
			<ion-col size="12" class="ion-no-padding">
				<ion-item class="container privacy-checkbox" lines="none">
					<div class="checkbox-item">
						<ion-checkbox
							[(ngModel)]="ageVerified"
							mode="md"
							(keydown.space)="changeAgeVerification()"
							(ionChange)="changeAgeVerification()"
							aria-labelledby="age-verification-label"
							tabindex="0"
						>
						</ion-checkbox>
					</div>
					<label id="age-verification-label" class="din-pro-cond-med ion-margin-start" (click)="changeAgeVerification()">
						{{ 'checkout_modal.certificate_18' | translate }}
					</label>
				</ion-item>
			</ion-col>
		</ion-row>

		<div class="separator"><div class="line" aria-hidden="true"></div></div>

		<!-- Cart totals and checkout section -->
		<div class="button-row" *ngIf="hasArticles">
			<!-- Promo code section -->
			<div class="add-promo-section" *ngIf="hasArticles">
				<div class="wrapper-promo">
					<!-- Add promo button -->
					<button
						class="add-promo-block"
						[class.border-bottom]="order?.promoCode"
						(click)="navToPromo()"
						aria-label="Customize and add promo"
					>
						<ion-img src="../../../assets/dean_and_david/find_promo.png" aria-hidden="true"></ion-img>
						<div class="block-text">
							<h3>{{ 'add_promo_dialog.promotions_title' | translate }}</h3>
							<p>
								{{ 'add_promo_dialog.promotions_description' | translate }}
							</p>
						</div>
						<ion-img class="chevron" src="../../../assets/dean_and_david/chevron-down.png" aria-hidden="true"></ion-img>
					</button>

					<!-- Applied promo code section -->
					<div *ngIf="order?.promoCode" role="status" aria-live="polite">
						<div class="add-promocode-wrapper">
							<ion-icon
								class="submit-button"
								src="../../../assets/dean_and_david/promocode-add.svg"
								aria-hidden="true"
							></ion-icon>
							<div class="name-of-promo">
								<h2 *ngIf="order.promoCode.name" class="name">{{ order.promoCode.name }}</h2>
								<h3 class="discount">
									{{
										numberToCurrency(
											ou.orderTotalPrice(order, true, true) - ou.orderTotalPriceWithoutDiscounts(order),
											order.currency
										)
									}}
								</h3>
							</div>
							<div class="edit_section">
								<!-- Remove promo button -->
								<button
									class="edit-btn bsg-remove-promo"
									(click)="removePromoAndEmit()"
									aria-label="Remove promotion code"
									tabindex="0"
								>
									<ion-icon src="../../../assets/dean_and_david/delete_article.svg" aria-hidden="true"></ion-icon>
									<span class="visually-hidden">Remove promo code</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Price summary section -->
			<div class="sub-total">
				<p class="sub-total-title" id="subtotal-label">{{ 'subtotal' | translate }}</p>
				<p class="sub-total-sum" aria-labelledby="subtotal-label">{{ totlaPriceBeforeDiscount }}</p>
			</div>

			<div class="sub-total">
				<p class="sub-total-title" id="taxes-label">{{ 'taxes' | translate }}</p>
				<p class="sub-total-sum" aria-labelledby="taxes-label">{{ taxesValue }}</p>
			</div>

			<!-- Delivery fee section -->
			<div class="sub-total" *ngIf="order && order?.orderedArticles && order?.preorder?.type === pt.DELIVERY">
				<p class="sub-total-title" id="delivery-label">Delivery</p>
				<p class="sub-total-sum" *ngIf="order?.preorder" aria-labelledby="delivery-label">
					<ng-container *ngIf="!ou.isFreeDeliveryPromo(order)">
						+{{ numberToCurrency(order?.preorder?.deliveryFee ?? 0, order.currency) }}
					</ng-container>
					<ng-container *ngIf="ou.isFreeDeliveryPromo(order)">{{ numberToCurrency(0, order.currency) }} </ng-container>
				</p>
			</div>

			<!-- Store discount -->
			<div class="sub-total" *ngIf="order?.preorder?.type === pt.FOOD_SPOT && storeDiscount">
				<p class="sub-total-title" id="store-discount-label">Store Discount</p>
				<p class="sub-total-sum" aria-labelledby="store-discount-label">{{ storeDiscount }}</p>
			</div>

			<!-- Company discount -->
			<div class="sub-total" *ngIf="companyDisount">
				<p class="sub-total-title" id="company-discount-label">{{ 'menu_page.subsidy' | translate }}</p>
				<p class="sub-total-sum" aria-labelledby="company-discount-label">{{ companyDisount }}</p>
			</div>

			<!-- Promo code discount -->
			<div class="sub-total" *ngIf="order?.promoCode">
				<p class="sub-total-title" id="promo-discount-label">Promocode: {{ order?.promoCode?.name }}</p>
				<p class="sub-total-sum" aria-labelledby="promo-discount-label">
					{{
						numberToCurrency(ou.orderTotalPrice(order, true, true) - ou.orderTotalPriceWithoutDiscounts(order), order.currency)
					}}
				</p>
			</div>

			<!-- Minimum order warnings -->
			<div class="sub-total" *ngIf="minFoodSpotSubsidy > 0" role="alert">
				<p class="error-message">
					Please, achieve minimum price for Food Spot Order: {{ numberToCurrency(minFoodSpotSubsidy, order.currency) }}
				</p>
			</div>

			<p class="error-message" *ngIf="differenceToMvo && differenceToMvo < 0" role="alert">
				{{ 'order.min_price' | translate }}
				{{ numberToCurrency(-differenceToMvo, order.currency) }}
			</p>

			<ion-icon class="border-line" src="../../../assets/dean_and_david/border-line.svg" aria-hidden="true"></ion-icon>

			<!-- Order total -->
			<div class="total">
				<p class="total-title" id="total-label">{{ 'order.total' | translate }}</p>
				<p class="total-sum" aria-labelledby="total-label">{{ totalPriceValue }}</p>
			</div>

			<!-- Checkout button -->
			<button
				class="footer-btn"
				[class.invalid]="!isValid"
				[disabled]="!isValid || loading"
				(click)="openCheckoutModal()"
				(keydown.enter)="isValid && !loading ? openCheckoutModal() : null"
				(keydown.space)="isValid && !loading ? openCheckoutModal() : null"
				aria-label="Proceed to payment"
				tabindex="0"
			>
				<h2 class="footer-btn-text" *ngIf="!loading">
					{{ 'order.pay' | translate }}
				</h2>
				<ion-spinner *ngIf="loading" class="white center" name="crescent" aria-label="Loading"></ion-spinner>
			</button>
		</div>
	</footer>
</ion-col>
